import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';

/**
 * Wraps content and only renders children if the user has the required permission.
 * Admins bypass all checks. Redirects to home if access is denied.
 */
const PermissionGate = ({ permission, children }) => {
  const { hasPermission } = usePermissions();

  if (hasPermission(permission)) {
    return children;
  }

  return <Navigate to="/" replace />;
};

export default PermissionGate;
